(function ($) {
    function toggleSearch() {
        var brand_bar = $("#brand__bar");
        var search_toggle = $("#toggle__search");
        var resources_toggle = $("#toggle__resources");
        var schools_toggle = $("#toggle__schools");
        var logins_toggle = $("#toggle__logins");
        var personas_toggle = $("#toggle__personas");
        var search_panel = $("#panel__search");
        var resources_panel = $("#panel__resources");
        var schools_panel = $("#panel__schools");
        var logins_panel = $("#panel__logins");
        var personas_panel = $("#panel__personas");

        // Toggle search when tapping the button
        search_toggle.click(function () {
            var panel_height = search_panel.outerHeight();
            var search_input = search_panel.find("input.search-input");

            search_input.focus();
            $("body").toggleClass("search-open");

            resources_toggle
                .attr("aria-pressed", "false")
                .removeClass("toggle__resources--active");
            resources_panel
                .attr("aria-expanded", "false")
                .removeClass("panel__resources--active");
            schools_toggle
                .attr("aria-selected", "false")
                .removeClass("toggle__schools--active");
            schools_panel
                .attr("aria-expanded", "false")
                .removeClass("panel__schools--active");
            logins_toggle
                .attr("aria-pressed", "false")
                .removeClass("toggle__logins--active");
            logins_panel
                .attr("aria-expanded", "false")
                .removeClass("panel__logins--active");
            personas_toggle
                .attr("aria-pressed", "false")
                .removeClass("toggle__personas--active");
            personas_panel
                .attr("aria-expanded", "false")
                .removeClass("panel__personas--active");

            if (search_toggle.hasClass("toggle__search--active")) {
                // If search toggle is active, close the search panel
                search_toggle
                    .removeClass("toggle__search--active")
                    .addClass("toggle__search--inactive");
                search_panel.removeClass("panel__search--active");

                setTimeout(function () {
                    search_panel.attr("aria-expanded", "false");
                    search_panel.addClass("panel__search--inactive");
                    brand_bar.removeAttr("style");
                }, 150); // Delay the panel closing for better animation
            } else {
                // If search toggle is inactive, open the search panel
                search_toggle
                    .addClass("toggle__search--active")
                    .removeClass("toggle__search--inactive");
                search_panel
                    .addClass("panel__search--active")
                    .removeClass("panel__search--inactive");
                search_panel.attr("aria-expanded", "true");
                brand_bar.css("margin-top", panel_height);
            }
        });
    }

    function resetSearch() {
        var brand_bar = $("#brand__bar");
        var search_toggle = $("#toggle__search");
        var search_panel = $("#panel__search");

        // Reset any bindings
        search_toggle.unbind("click");

        // Reset search toggle & panel if they are active
        search_toggle
            .attr("aria-pressed", "false")
            .removeClass("toggle__search--active");
        search_panel
            .attr("aria-expanded", "false")
            .removeClass("panel__search--active");
        brand_bar.removeAttr("style");
    }

    var urlKey;
    var upperLengthLimit = 130;

    function urlIterator(url) {
        var urlParts = url.split("/");
        urlParts.pop();
        var shortUrl = urlParts.join("/");
        return returnNewUrl(shortUrl);
    }

    function returnNewUrl(url) {
        var origUrl = url;
        var shortUrl = url + "/.../" + urlKey;
        if (shortUrl.length > upperLengthLimit) {
            return urlIterator(origUrl);
        } else {
            return shortUrl;
        }
    }

    function urlInit(url) {
        var urlParts = url.split("/");
        urlKey = urlParts[urlParts.length - 2];
        var host = [urlParts[0], urlParts[1], urlParts[2]];
        if (urlKey.length > upperLengthLimit) {
            return host.join("/");
        } else if (url.length > upperLengthLimit) {
            return urlIterator(url);
        } else {
            return url;
        }
    }

    function getUrlVars() {
        var vars = [],
            hash;
        var hashes = window.location.href
            .slice(window.location.href.indexOf("#") + 1)
            .split("&");

        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split("=");
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    function getDescription(item) {
        if (
            typeof item["yoast_description"] !== "undefined" &&
            item["yoast_description"].length > 0
        ) {
            return maxChar(item["yoast_description"]);
        } else if (
            typeof item["description"] !== "undefined" &&
            item["description"].length > 0
        ) {
            return maxChar(item["description"]);
        } else {
            return maxChar(item["body"]);
        }
    }

    function maxChar(body) {
        var origBody = body;
        if (origBody.length > 300) {
            origBody = body.substring(0, 300);
            return origBody + " ...";
        } else {
            return body;
        }
    }

    var currentCampbellFilter = {};

    function campbellFilters() {
        return window.currentCampbellFilter;
    }

    var currentSearchField = {};

    function campbellSearchField() {
        return window.currentSearchField;
    }

    var currentSearchDirection = {};

    function campbellSearchDirection() {
        return window.currentSearchDirection;
    }

    function sortResults() {
        //first run
        if ($(".sort:selected").data("field") === "date") {
            window.currentSearchField = { page: "published_at" };
            window.currentSearchDirection = { page: "desc" };
        } else {
            window.currentSearchField = {};
            window.currentSearchDirection = {};
        }

        $(".st-sort").on("change", function () {
            // Visually change the selected sorting order
            $(this)
                .find(":selected")
                .addClass("selected")
                .siblings("option")
                .removeClass("selected");
            // Update sorting settings
            if ($(".sort:selected").data("field") === "date") {
                window.currentSearchField = { page: "published_at" };
                window.currentSearchDirection = { page: "desc" };
            } else {
                window.currentSearchField = {};
                window.currentSearchDirection = {};
            }

            $(window).hashchange();
        });
    }

    function switchTab($clickedTab) {
        if ($clickedTab !== "undefined") {
            var siteId = $clickedTab.attr("data-id");
            var siteIds = siteId.split(" ");

            if (siteId > 0 && siteId != 3 && siteId != 4 && siteId != 6) {
                window.currentCampbellFilter = { page: { site_id: siteIds } }; //[1, 5]
            } else if (siteId == 3) {
                window.currentCampbellFilter = { page: { site_id: 3 } };
            } else if (siteId == 4) {
                window.currentCampbellFilter = { page: { site_id: 4 } };
            } else if (siteId == 6) {
                window.currentCampbellFilter = { page: { site_id: 6 } };
            } else {
                window.currentCampbellFilter = {};
            }
            var query = getUrlVars()["stq"];
            window.location.hash = "#stq=" + query + "&stp=1";
            $(window).hashchange();
        }
    }

    function activateTab() {
        $(".search-tabs__tab").on("click", function (e) {
            var $tab = $(this);
            var activeTab = $(this).attr("aria-controls");

            $(".search-tabs > .search-tabs__tab").attr(
                "aria-selected",
                "false"
            );
            // Update attributes on selected
            $(this).attr("aria-selected", "true");
            switchTab($tab);
        });
    }

    function searchInit() {
        $("#st-search-input").swiftypeSearch({
            renderFunction: function (document_type, item) {
                var itemDate = "";
                var img = item["image"]
                    ? '<img class="result__image" src="' + item["image"] + '"/>'
                    : "";
                var out =
                    '<div class="result">' +
                    '<div class="result__title">' +
                    '<a href="' +
                    item["url"] +
                    '">' +
                    item["title"] +
                    "</a>" +
                    "</div>";
                out = out.concat(
                    '<div class="result__url">' +
                        urlInit(item["url"]) +
                        "</div>"
                );
                if (
                    item["site_id"] == 3 ||
                    item["site_id"] == 4 ||
                    item["site_id"] == 8
                ) {
                    itemDate =
                        new Intl.DateTimeFormat("en-Us", {
                            dateStyle: "long",
                        }).format(new Date(item["published_at"])) + " - ";
                }
                out = out.concat(
                    '<div class="result__container">' +
                        img +
                        '<div class="result__excerpt">' +
                        itemDate +
                        getDescription(item) +
                        "</div>" +
                        "</div>"
                );
                return out;
            },
            renderPaginationForType: function (type, currentPage, totalPages) {
                var pages = '<div class="search-pagination">';
                var i = 1;
                var total = totalPages < 10 ? totalPages : 10;
                var active =
                    getUrlVars()["stp"] == null ? 1 : getUrlVars()["stp"];
                var query = getUrlVars()["stq"];
                var protocol = window.location.protocol;
                var host = window.location.hostname;
                var path = window.location.pathname;
                while (i <= total) {
                    var current = i == active ? "current" : "";
                    pages =
                        pages +
                        '<a href="' +
                        protocol +
                        "//" +
                        host +
                        path +
                        "#stq=" +
                        query +
                        "&stp=" +
                        i +
                        '" class="search-pagination__page-number ' +
                        current +
                        '" data-hash="true">' +
                        i +
                        "</a>";
                    i++;
                }
                pages += "</div>";
                return pages;
            },
            postRenderFunction: function (data) {
                var totalResultCount = 0;
                var $resultContainer = this.getContext().resultContainer;
                var spellingSuggestion = null;
                if (data["info"]) {
                    $.each(data["info"], function (index, value) {
                        totalResultCount += value["total_result_count"];
                        $(".st-results-count", $(".st-results-container")).html(
                            "About " + totalResultCount + " results"
                        );
                        if (value["spelling_suggestion"]) {
                            spellingSuggestion =
                                value["spelling_suggestion"]["text"];
                        }
                    });
                }

                if (totalResultCount === 0) {
                    $resultContainer.html(
                        "<div id='st-no-results' class='st-no-results'>No results found.</div>"
                    );
                }

                if (spellingSuggestion !== null) {
                    $resultContainer.append(
                        '<div class="st-spelling-suggestion">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' +
                            spellingSuggestion +
                            '">' +
                            spellingSuggestion +
                            "</a>?</div>"
                    );
                }
            },
            loadingFunction: function (query, $resultContainer) {
                $resultContainer.html("");
            },
            fetchFields: {
                page: [
                    "title",
                    "url",
                    "body",
                    "image",
                    "yoast_description",
                    "published_at",
                    "site_id",
                    "description",
                ],
            },
            resultContainingElement: $(
                ".st-results",
                $(".st-results-container")
            ).get(0),
            engineKey: "qvCyzCF-L4euJAaHNJBK",
            highlightFields: {
                page: { body: { fallback: true } },
            },
            sortField: campbellSearchField,
            sortDirection: campbellSearchDirection,
            filters: campbellFilters,
        });
    }

    $(document).ready(function () {
        activateTab();
        sortResults();
        if ($(".page-template-search").length > 0) {
            switchTab($("#tab1"));
        }
        searchInit();

        // set up autocomplete
        $("#st-search-input").swiftype({
            searchFields: { page: ["body"] },
            engineKey: "qvCyzCF-L4euJAaHNJBK",
        });

        if (!$(".page-template-search").length > 0) {
            //Don't run this on the search page
            // redirect form to results page with #stq hash parameter
            $("#search-form").submit(function (event) {
                event.preventDefault();
                var query = $("#st-search-input").val();
                var newUrl =
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    "/search/#stq=" +
                    query;
                // set the location to be the URL of your search results page
                // For this example, it's results.html.
                if (query) {
                    window.location.href = newUrl;
                }
            });
        }

        $(".alt-search").submit(function (event) {
            event.preventDefault();
            var query = $(".alt-input").val();
            var newUrl =
                window.location.protocol +
                "//" +
                window.location.hostname +
                "/search/#stq=" +
                query;
            // set the location to be the URL of your search results page
            // For this example, it's results.html.
            window.location.href = newUrl;
        });

        if (
            $(".site-id-2").length > 0 ||
            $(".site-id-3").length > 0 ||
            $(".site-id-4").length > 0 ||
            $(".site-id-5").length > 0 ||
            $(".site-id-6").length > 0
        ) {
            $("#search-form").submit(function (event) {
                event.preventDefault();
                var query = $("#st-search-input").val();
                var campbellUrl = $("meta[name=campbell-url]").attr("content");
                var newUrl = campbellUrl + "/search/#stq=" + query;
                // set the location to be the URL of your search results page
                // For this example, it's results.html.
                if (query) {
                    window.location.href = newUrl;
                }
            });
        }

        if ($(".post-type-archive-people").length > 0) {
            $(".alt-search").submit(function (event) {
                event.preventDefault();
                var query = $(".alt-input").val();
                var directoryUrl = $("meta[name=directory-url]").attr(
                    "content"
                );
                var newUrl = directoryUrl + "/search/#stq=" + query;
                // set the location to be the URL of your search results page
                // For this example, it's results.html.
                if (query) {
                    window.location.href = newUrl;
                }
            });
        }
    });

    // Laptop/Desktop:
    // Restructure header to include brand bar and site bar
    enquire.register("screen and (min-width: 960px)", {
        // =====================================================
        // Triggered when a media query matches
        // =====================================================
        match: function () {
            resetSearch();
            toggleSearch();
        },

        // =====================================================
        // Triggered when a media query transitions from a
        // matched state to an unmatched state
        // =====================================================
        unmatch: function () {
            resetSearch();
            toggleSearch();
        },

        // =====================================================
        // Triggered once, when the handler is registered
        // =====================================================
        setup: function () {
            toggleSearch();
        },
    });
})(jQuery);
